import { State } from 'app/redux';

export const getTranslations = (state: State) => state.translations;
